<template>
  <div class="diy-card-catalogue">
    <div class="diy-card-catalogue__wrapper">
      <!-- ACTIONS -->
      <div class="diy-card-catalogue__actions">
        <ModalCloseButton />
      </div>
      <!-- LISTING -->
      <div class="diy-card-catalogue__listing">
        <CardCatalogueSection v-for="key in catalogueKeys" :key="key" :cards="catalogue[key]" />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import CardCatalogueSection from './components/CardCatalogueSection'
import ModalCloseButton from 'Modules/Card/common/components/ModalCloseButton'

export default {
  name: 'CardCatalogue',

  components: {
    ModalCloseButton,
    CardCatalogueSection,
  },

  props: {
    catalogue: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      catalogueKeys: null,
    }
  },

  computed: {},

  mounted() {
    console.log(this.catalogue)
    this.catalogueKeys = Object.keys(this.catalogue)
  },
}
</script>

<style scoped>
.diy-card-catalogue__wrapper {
  padding: 10px 10px 30px;
  background-color: #fff;
  border-radius: 10px;
}

.diy-card-catalogue__actions {
  text-align: right;
}

.diy-card-catalogue__actions .app-button--icon {
  display: inline-block;
}

.diy-card-catalogue__section:not(:first-of-type) {
  margin-top: 60px;
}
</style>
